import { SxProps, Theme } from '@mui/material'

export const dataGridSx: SxProps<Theme> = {
  flex: 1,
  border: 'none',
  '.MuiDataGrid-columnHeaders div:first-of-type': {
    bgcolor: 'secondary.main',
    color: 'white',
    fontWeight: 'bold',
    borderRadius: '8px 8px 0 0',
  },
  '.MuiDataGrid-cell': {
    fontWeight: 500,
  },
  '.MuiDataGrid-sortIcon': { color: 'white' },
}
